import {
    Label,
    Switch as ReactAriaSwitch,
    SwitchProps,
} from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type SwitchProperties = SwitchProps & {
    label?: string
    className?: string
    error?: boolean
    errorMessage?: string
}

export const Switch = ({
    label,
    className,
    error,
    errorMessage,
    ...properties
}: Readonly<SwitchProperties>): JSX.Element => {
    return (
        <>
            <ReactAriaSwitch
                className={joinStyles(styles.switchGroup, className)}
                {...properties}
            >
                <div className={styles.indicator} />

                {!!label && <Label className={styles.label}>{label}</Label>}
            </ReactAriaSwitch>

            {!!error && !!errorMessage && (
                <div className={styles.error}>{errorMessage}</div>
            )}
        </>
    )
}
